// extracted by mini-css-extract-plugin
module.exports = {"links":"LinkList_links__9D9qE","linkWrapper":"LinkList_linkWrapper__7Mn6q","link":"LinkList_link__RXjBg"};